// extracted by css-extract-rspack-plugin
export default {"root":"root-QgWEYU","info":"info-wKOijm","percentage":"percentage-iqrCaf text-5xl","completionCount":"completionCount-zrZRFl text-sm"};